module.exports = __webpack_public_path__ + "img/Lina.b33a5dd5.svg";